import { Component } from '@angular/core'

@Component({
  selector: 'flowaccount-dac-highlight',
  templateUrl: './dac-highlight.component.html',
  styleUrls: ['./dac-highlight.component.scss'],
})
export class DacHighlightComponent {
  highlightItems = [
    {
      icon: 'https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/highlight/trend.svg',
      title: 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.HIGHLIGHT.1.TITLE',
      desc: 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.HIGHLIGHT.1.DETAIL',
    },
    {
      icon: 'https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/highlight/learn.svg',
      title: 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.HIGHLIGHT.2.TITLE',
      desc: 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.HIGHLIGHT.2.DETAIL',
    },
    {
      icon: 'https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/highlight/demo.svg',
      title: 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.HIGHLIGHT.3.TITLE',
      desc: 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.HIGHLIGHT.3.DETAIL',
    },
    {
      icon: 'https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/highlight/network.svg',
      title: 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.HIGHLIGHT.4.TITLE',
      desc: 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.HIGHLIGHT.4.DETAIL',
    },
  ]
}
